<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    :clear-on-destroy="!isEdit"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <PTOProjectTitle v-if="isEdit" is-edit />

    <VInput
      label="Наименование ППР"
      name="name"
      required
      min-length="3"
    >
      <Validation for="required">Поле обязательно</Validation>
      <Validation for="minLength">Минимальная длина названия 3 символа</Validation>
    </VInput>

    <AppInputDate
      title="Дата выдачи ППР"
      name="develop_date"
      type="single"
    />

    <VSelect
      label="Разработчик ППР"
      name="developer"
      :items="userList"
      :handler-search="GETUserList"
      search
      userSelect
    />

    <VSelect
      label="МОЛ"
      name="mol"
      :items="userList"
      :handler-search="GETUserList"
      search
      required
      userSelect
    >
      <Validation for="required">Поле обязательно</Validation>
    </VSelect>

    <AppInputFile
      title="Загрузите файл"
      class="form__input--col-2"
      name="files"
      @delete-file="ADD_FILE_TO_DELETE"
    />
  </FormPto>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import AppInputFile from '@/components/page/input/AppInputFile'
import FormPto from '@/components/pto/form/FormPto'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import Validation from '@/components/page/Form/Validation.vue'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'

import { mapMutations } from 'vuex'
import { prepareProjectPtoPPRFormData } from '@/utils/page/pto/project/pto'

export default {
  name: 'FormPtoProjectPtoPPR',
  components: {
    AppInputDate,
    AppInputFile,
    FormPto,
    PTOProjectTitle,
    // eslint-disable-next-line vue/no-unused-components
    Validation,
    VInput,
    VSelect
  },

  mixins: [
    MIXIN_FORM_PTO,
    MIXIN_USER_LIST
  ],

  destroyed () {
    this.RESET_FILES_TO_DELETE()
  },

  methods: {
    ...mapMutations('pto/project/pto/ppr', {
      RESET_FILES_TO_DELETE: 'RESET_FILES_TO_DELETE',
      ADD_FILE_TO_DELETE: 'ADD_FILE_TO_DELETE'
    }),

    onSubmit (data) {
      this.$emit('request', prepareProjectPtoPPRFormData(data))
    }
  }
}
</script>
